import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Switch from '@mui/material/Switch';
import * as React from 'react';
import { InputComponentProps } from '../../../../../../../../design-system';
import { toChangeEvent } from '../../../../../../../../utils/formUtils';

export const TokenRequiredSwitchInput: React.FC<InputComponentProps<boolean>> = ({
  name,
  value,
  disabled,
  onBlur,
  onChange,
  helperText,
  error,
}) => (
  <FormControl>
    <Switch
      id={name}
      color="primary"
      checked={value}
      disabled={disabled}
      onBlur={onBlur}
      onChange={(event, checked) => onChange(name)(toChangeEvent(event, checked))}
    />
    {helperText && (
      <FormHelperText variant="outlined" error={error}>
        {helperText}
      </FormHelperText>
    )}
  </FormControl>
);
